import { EDIT_FORMDEFINITION_TABS } from "developer/formsCRUD/constants";
import { FormDefinition } from "developer/formsCRUD/store/formDefinitionsSlice";
import {
  addFormDefinitionStage,
  deleteFormDefinitionStage,
  editFormDefinitionStages,
  handleChangeFormDefinitionStage,
  handleChangeInitialStage,
  reorderFormDefinitionStages,
  resetStagesState,
  setStagesError,
  Stage,
} from "developer/formsCRUD/store/formDefinitionStagesSlice";
import { useCallback, useEffect } from "react";
import { DropResult } from "react-beautiful-dnd";
import { useAppDispatch, useAppSelector } from "store/hooks";
import TabPanel from "../TabPanel";
import StagesTab from "./StagesTab";

type StagesTabPanelProps = {
  tabSelected: number;
  formDefinition: FormDefinition;
  formDefinitionList: FormDefinition[];
  onClose: () => void;
};

const StagesTabPanel = (props: StagesTabPanelProps) => {
  const { tabSelected, formDefinition, formDefinitionList, onClose } = props;
  const dispatch = useAppDispatch();

  const { stagesEdited, hasStagesError, initialStageName } = useAppSelector(
    (state) => {
      return state.developer.stagesCRUD;
    }
  );

  useEffect(() => {
    return () => {
      dispatch(resetStagesState());
    };
  }, [dispatch]);

  const handleSubmit = useCallback(() => {
    const hasStagesWithErrors: boolean = stagesEdited!.some(
      ({ name, formDefinitionId }) => !name || !formDefinitionId
    );
    if (hasStagesWithErrors) {
      dispatch(setStagesError(true));
      return;
    }
    dispatch(editFormDefinitionStages(formDefinition.id));
    onClose();
  }, [stagesEdited, formDefinition.id, dispatch, onClose]);

  const handleChangeStage = (index: number, newStage: Partial<Stage>) => {
    dispatch(
      handleChangeFormDefinitionStage({
        index,
        newStage,
      })
    );
  };

  const handleChangeInitialStageValue = (value: string) => {
    dispatch(handleChangeInitialStage(value));
  };

  const handleClickAddStage = () => {
    dispatch(addFormDefinitionStage());
  };

  const handleClickDeleteStage = (index: number) => {
    dispatch(deleteFormDefinitionStage({ index }));
  };

  const handleDragEndStage = (result: DropResult) => {
    const { destination, source } = result;

    if (
      !destination ||
      (source.index === destination.index &&
        source.droppableId === destination.droppableId)
    ) {
      return;
    }

    dispatch(
      reorderFormDefinitionStages({
        sourceIndex: source.index,
        destinationIndex: destination.index,
      })
    );
  };

  return (
    <TabPanel value={tabSelected} index={EDIT_FORMDEFINITION_TABS.Stages}>
      <StagesTab
        stages={stagesEdited ?? []}
        initialStageName={initialStageName ?? "Envío de Formulario"}
        formDefinitions={formDefinitionList}
        onClickAddStage={handleClickAddStage}
        onChangeInitialStage={handleChangeInitialStageValue}
        onChangeStage={handleChangeStage}
        onDeleteStage={handleClickDeleteStage}
        onDragEndStage={handleDragEndStage}
        hasStagesError={hasStagesError}
        onSubmit={handleSubmit}
      />
    </TabPanel>
  );
};

export default StagesTabPanel;
